import { useMemo, useState } from 'react'
import { icons } from 'lucide-react'
import { Input } from '@/view/components/ui/input'
import { cn } from '@/app/utils/cn'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from './ui/dropdown-menu'
import { Button } from './ui/button'

export type IconName = keyof typeof icons

interface IconPickerProps {
  value: IconName
  onChange: (icon: IconName) => void
}

export const IconPicker = ({ value, onChange }: IconPickerProps) => {
  const [search, setSearch] = useState('')
  const [open, setOpen] = useState(false)

  const iconNames = Object.keys(icons).filter((name) =>
    name.toLowerCase().includes(search.toLowerCase()),
  ) as IconName[]

  const SelectedIcon = useMemo(() => {
    if (!value) return null
    return icons[value]
  }, [value])

  const handleChangeIcon = (name: IconName) => {
    onChange(name)
    setOpen(false)
  }
  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" className="flex items-center gap-2">
          {SelectedIcon && <SelectedIcon size={18} />}
          {!value && 'Selecionar ícone'}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-64 p-2" align="end">
        <Input
          placeholder="Buscar ícone..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="mb-2"
        />
        <div className="grid max-h-48 grid-cols-6 gap-2 overflow-y-auto rounded p-1">
          {iconNames.map((iconName) => {
            const Icon = icons[iconName]
            const selected = iconName === value

            return (
              <button
                type="button"
                key={iconName}
                title={iconName}
                onClick={() => handleChangeIcon(iconName)}
                className={cn(
                  'flex items-center justify-center rounded p-2 transition-colors hover:bg-muted',
                  selected && 'bg-primary text-white',
                )}
              >
                <Icon size={20} />
              </button>
            )
          })}
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
